<template>
  <div id="app" style="height:100%" :data-theme="nowThemeInfo">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed:{
  	nowThemeInfo(){
  		return this.$store.state.nowThemeInfo;
  	}
  }
}
</script>

<style>
*{ margin:0; padding:0;  font-family:"微软雅黑";}
html, body {
  height: 100vh;
}
#app {
  font-family: '微软雅黑', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #1243cb;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #ededed;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue